// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-pages-explorer-filter__container {
    margin-top: 10px;
}

.home-pages-explorer-filter__accordion.MuiPaper-elevation1{
    box-shadow: none;
}

.home-pages-explorer-filter__accordion.MuiAccordion-root {
    position: initial;
    margin: 16px 0;
}

.home-pages-explorer-filter__accordion .MuiAccordionSummary-root.Mui-expanded{
    min-height: 48px;
} 

.home-pages-explorer-filter__accordion .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
}


.home-pages-explorer-filter__accordion__option.baloa-names {
    font-weight: var(--font-regular);
}

.home-pages-explorer-filter__accordion .MuiAccordionDetails-root {
    padding: 0 12px;
}

.home-pages-explorer-filter__accordion .MuiAccordionSummary-root {
    padding: 0 12px;
}

.home-pages-explorer-filter__option-button .baloa-names,
.home-pages-explorer-filter__checkbox .baloa-names  {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
}

.home-pages-explorer-filter__option-button .MuiFormControlLabel-root {
    border-bottom: solid 1px var(--new-gray-background-color);
    /*border-radius: 9px;
    padding: 3px 5px;
    height: 40px;*/
    /* padding: 16px 0; */
    margin: 0;
    width: 100%;
    margin-top: 12px;
}

.home-pages-explorer-filter__option-button .MuiFormControlLabel-root .MuiIconButton-root {
    padding: 16px 0;
    margin-right: 12px;
}

#panel2a-content .MuiAccordionDetails-root {
    display: block;
}

.home-pages-explorer-filter__checkbox.MuiFormControlLabel-root {
    display: block;
    margin: 0;
}

.home-pages-explorer-filter__checkbox .MuiIconButton-root {
    padding: 16px 0;
    margin-right: 12px;
}

.home-pages-explorer-filter__checkbox {
    border-bottom: solid 1px var(--new-gray-background-color);
    margin: 0;
    width: 100%;
    margin-top: 12px;
}

.home-pages-explorer-filter__container .input-search__input{
    background: var(--new-background-color);
    border-radius: 5px;
    margin: 0 12px;
    width: -webkit-fill-available;
}

.home-pages-explorer-filter__container .input-search__input .icon-search {
    color: #949F9A;
}

.home-pages-explorer-filter__container .input-search__input input {
    color: var(--primary-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .home-pages-explorer-filter__container {
        padding-top: 12px;
    }

    .home-pages-explorer-filter__mobile-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 12px;
    }

    .home-pages-explorer-filter__mobile-buttons__button{
        padding: 6px 10px;
        border: 1px solid var(--new-gray-background-color);
        background: var(--white-color);
        width: fit-content;
        border-radius: 5px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .home-pages-explorer-filter__mobile-buttons__button .baloa-names{
        font-weight: var(--font-regular);
    }

    .home-pages-explorer-filter__mobile-modal {
        border: 2px solid black;
        position: absolute;
        top: 0;
        background: var(--white-color);
        z-index: 12;
    }
    .home-pages-explorer-filter__mobile-modal.hide {
        display: none;
    }

    .home-pages-explorer-filter__mobile-submit-buttons {
        position: absolute;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: -webkit-fill-available;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/home-pages-explore-filter/HomePagesExploreFilterComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;;AAGA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,yDAAyD;IACzD;;kBAEc;IACd,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yDAAyD;IACzD,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,kDAAkD;QAClD,8BAA8B;QAC9B,kBAAkB;QAClB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,MAAM;QACN,8BAA8B;QAC9B,WAAW;IACf;IACA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,aAAa;QACb,mBAAmB;QACnB,6BAA6B;QAC7B,6BAA6B;IACjC;AACJ","sourcesContent":[".home-pages-explorer-filter__container {\n    margin-top: 10px;\n}\n\n.home-pages-explorer-filter__accordion.MuiPaper-elevation1{\n    box-shadow: none;\n}\n\n.home-pages-explorer-filter__accordion.MuiAccordion-root {\n    position: initial;\n    margin: 16px 0;\n}\n\n.home-pages-explorer-filter__accordion .MuiAccordionSummary-root.Mui-expanded{\n    min-height: 48px;\n} \n\n.home-pages-explorer-filter__accordion .MuiAccordionSummary-content.Mui-expanded {\n    margin: 0;\n}\n\n\n.home-pages-explorer-filter__accordion__option.baloa-names {\n    font-weight: var(--font-regular);\n}\n\n.home-pages-explorer-filter__accordion .MuiAccordionDetails-root {\n    padding: 0 12px;\n}\n\n.home-pages-explorer-filter__accordion .MuiAccordionSummary-root {\n    padding: 0 12px;\n}\n\n.home-pages-explorer-filter__option-button .baloa-names,\n.home-pages-explorer-filter__checkbox .baloa-names  {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n}\n\n.home-pages-explorer-filter__option-button .MuiFormControlLabel-root {\n    border-bottom: solid 1px var(--new-gray-background-color);\n    /*border-radius: 9px;\n    padding: 3px 5px;\n    height: 40px;*/\n    /* padding: 16px 0; */\n    margin: 0;\n    width: 100%;\n    margin-top: 12px;\n}\n\n.home-pages-explorer-filter__option-button .MuiFormControlLabel-root .MuiIconButton-root {\n    padding: 16px 0;\n    margin-right: 12px;\n}\n\n#panel2a-content .MuiAccordionDetails-root {\n    display: block;\n}\n\n.home-pages-explorer-filter__checkbox.MuiFormControlLabel-root {\n    display: block;\n    margin: 0;\n}\n\n.home-pages-explorer-filter__checkbox .MuiIconButton-root {\n    padding: 16px 0;\n    margin-right: 12px;\n}\n\n.home-pages-explorer-filter__checkbox {\n    border-bottom: solid 1px var(--new-gray-background-color);\n    margin: 0;\n    width: 100%;\n    margin-top: 12px;\n}\n\n.home-pages-explorer-filter__container .input-search__input{\n    background: var(--new-background-color);\n    border-radius: 5px;\n    margin: 0 12px;\n    width: -webkit-fill-available;\n}\n\n.home-pages-explorer-filter__container .input-search__input .icon-search {\n    color: #949F9A;\n}\n\n.home-pages-explorer-filter__container .input-search__input input {\n    color: var(--primary-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .home-pages-explorer-filter__container {\n        padding-top: 12px;\n    }\n\n    .home-pages-explorer-filter__mobile-buttons {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        padding: 12px;\n    }\n\n    .home-pages-explorer-filter__mobile-buttons__button{\n        padding: 6px 10px;\n        border: 1px solid var(--new-gray-background-color);\n        background: var(--white-color);\n        width: fit-content;\n        border-radius: 5px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    }\n\n    .home-pages-explorer-filter__mobile-buttons__button .baloa-names{\n        font-weight: var(--font-regular);\n    }\n\n    .home-pages-explorer-filter__mobile-modal {\n        border: 2px solid black;\n        position: absolute;\n        top: 0;\n        background: var(--white-color);\n        z-index: 12;\n    }\n    .home-pages-explorer-filter__mobile-modal.hide {\n        display: none;\n    }\n\n    .home-pages-explorer-filter__mobile-submit-buttons {\n        position: absolute;\n        bottom: 0;\n        display: flex;\n        align-items: center;\n        justify-content: space-evenly;\n        width: -webkit-fill-available;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
